import { command, selector as baseSelector } from '@/src/redux/store'
import { SLICE_NAME } from './state'


const selector = baseSelector[SLICE_NAME]


export { SLICE_NAME, command, selector }